import styled from "styled-components";
import {
  colors,
  spacings,
  borders
} from '../../../styles/theme'

export const Container = styled.div`
  position: relative;

  background: ${colors.white};
  padding: ${spacings.ls};
  border-radius: ${borders.lg};
`

export const WrapperButton = styled.div`
  position: absolute;
  right: 2rem;
  top: 1.75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  width: fit-content;
`

